module.exports = __webpack_public_path__ + "img/cart-o.aecc295e.png";